module.exports = __webpack_public_path__ + "img/facebook.adc9a646.svg";